module.exports = __webpack_public_path__ + "img/back-circular.62a34458.png";